/***@see : https://chakra-ui.com/docs/hooks/use-breakpoint-value */

import {useBreakpointValue} from "@chakra-ui/react";

export default useBreakpointValue;